import { GUEST, PERSON } from 'consts';
import { decryptPayerSSN } from 'sdk/payer';
import {
  businessColumnMeta,
  businessSearchFields,
  guestSearchFields,
  personColumnMeta,
  personSearchFields,
} from './config/payers';

export const formatPayerTypeSearchBy = (payerType) => ({
  field: 'type',
  operator: 'field',
  hide: true,
  value: payerType,
});

export const getColumnMeta = ({ auth, fspId, payerType }) => {
  return payerType === PERSON
    ? personColumnMeta(fspId, decryptPayerSSN, auth)
    : businessColumnMeta(fspId, decryptPayerSSN, auth);
};

export const getSearchFields = (payerType) => {
  if (payerType === PERSON) return personSearchFields;
  if (payerType === GUEST) return guestSearchFields;
  return businessSearchFields;
};
